<template>
<div ref="slideContent" :style="backgroundImageStyle" key="page-anim">
    <div id="alt-layout" class="mobile-background">
        <div class="under-header p-10">
            <div class="mobile-background">
                <h1 class="layoutHeader font-medium blur">{{ page?.altTitle || page?.title || 'Untitled Page' }}</h1>
                <Splitter class="featuredSplitterNew">
                    <SplitterPanel class="isotopesPanel" :size="55" :size-small="100">
                        <div class="pr-4">
                            <div v-if="page?.content" class="page-content large">
                                <div v-html="processedContent(page.content)"></div>
                            </div>
                            <div v-else class="text-500 text-center p-5">
                                <p>No content available</p>
                            </div>
                            <div v-if="page?.wistiaEmbed && isDirectVideoUrl(page.wistiaEmbed)" class="wistia-embed-alt">
                                <OfflineVideo :src="resolveVideoSrc(page.wistiaEmbed)" />
                            </div>
                            <div v-else-if="page?.wistiaEmbed" class="wistia-embed-alt">
                                <iframe :src="getWistiaEmbedUrl(page.wistiaEmbed)" webkit-playsinline="true" playsinline allowfullscreen="false" frameborder="0"></iframe>
                            </div>
                            <div v-if="page?.contentImage" class="wistia-embed">
                                <img :src="resolveImageUrl(page.contentImage)" :alt="`${page?.altTitle || page?.title || 'Content'} image`">
                            </div>
                        </div>
                    </SplitterPanel>
                    <SplitterPanel class="overlay isotopesPanel" :size="45" :size-small="100">
                        <div class="pl-4">
                            <div v-if="page?.secondContentAlt" class="page-content">
                                <div v-html="processedContent(page.secondContentAlt)"></div>
                                <button 
                                    @click="goToPage('9', $refs.slideContent)" 
                                    class="cta cta--isotopes cursor-pointer text-white px-4 py-2 flex items-center rounded-small"
                                    aria-label="Navigate to enquiry page"
                                    title="Click to here enquire"
                                >
                                    Click to here enquire
                                </button>
                            </div>
                            <div v-else class="text-500 text-center p-5">No content</div>
                        </div>
                    </SplitterPanel>
                </Splitter>
            </div>
        </div>
    </div>
</div>
</template>
<script setup>
import Splitter from 'primevue/splitter';
import SplitterPanel from 'primevue/splitterpanel';
import OfflineVideo from '../components/OfflineVideo.vue';
import { computed } from 'vue';
import { useNavigation } from '../composables/useNavigation.js';
import { processContent } from '../utils/markdown.js';
import { useCommonStyles } from '../composables/useCommonStyles.js';
import { useMediaHelpers } from '../composables/useMediaHelpers.js';

const { goToPage } = useNavigation();

const props = defineProps({
  page: Object,
  settings: Object
});

const { isDirectVideoUrl, resolveVideoSrc, resolveImageUrl, getWistiaEmbedUrl } = useMediaHelpers();

// Use common styles composable
const { backgroundImageStyle } = useCommonStyles(props);

// Process second content area with markdown
const processedContent = (content) => {
  return content ? processContent(content) : '';
};

</script>   